import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import React, { useCallback, useContext } from 'react';
import { BonusRecordTaggingContext } from './BonusRecordTaggingProvider';
import Form from '../../../../kingpin/forms/Form';
import FormHeader from '../../../../kingpin/forms/FormHeader';
import Row from '../../../Common/Row';
import Button from '../../../../kingpin/atoms/Button';
import CloudFunctionClientContext from '../../../../contexts/CloudFunctionClientContext';
import { BonusOverviewContext } from '../../providers/BonusOverviewProvider';
import removeBonusTag from '../../api/removeBonusTag';
import getRecordTaggingFieldKey from './getRecordTaggingFieldKey';

const DeletePopup = ({ close }: { close: () => void }) => {
  const {
    gridConfig,
    taggedDocumentIds,
    configuredTag,
    setSelectedDocumentIds,
    setTaggedDocumentIds,
  } = useContext(BonusRecordTaggingContext);
  const { bonusOverview, currentMode, setFieldTagCount } =
    useContext(BonusOverviewContext);
  const { api } = useContext(CloudFunctionClientContext);
  const [isSaving, setIsSaving] = React.useState(false);

  const onDelete = useCallback(() => {
    if (!bonusOverview || !gridConfig) return;

    if (!taggedDocumentIds.length) {
      close();
      return;
    }

    setIsSaving(true);
    removeBonusTag({
      api,
      bonusProgramId: bonusOverview.bonusProgram.id,
      period: bonusOverview.bonusPeriod.id,
      driver: bonusOverview.driver,
      tag: configuredTag,
      recordIds: taggedDocumentIds,
      dataType: gridConfig.dataType,
    }).then((response) => {
      if (response.ok) {
        setSelectedDocumentIds([]);
        setTaggedDocumentIds([]);
        // Optimistically clear the count on the expectations list.
        if (currentMode.taggableField) {
          setFieldTagCount(
            getRecordTaggingFieldKey({
              fieldType: currentMode.fieldType ?? 'criteria',
              fieldName: currentMode.taggableField.name,
            }),
            0,
          );
        }
      }
      setIsSaving(false);
      close();
    });
  }, [
    api,
    bonusOverview,
    close,
    configuredTag,
    currentMode.taggableField,
    currentMode.fieldType,
    taggedDocumentIds,
    gridConfig,
    setFieldTagCount,
    setSelectedDocumentIds,
    setTaggedDocumentIds,
  ]);

  return (
    <Form>
      <FormHeader title={'Remove exclusions'} onClose={close} />
      <Row spaceBetween>
        <Button
          size={'Small'}
          type={'Secondary'}
          label={'Cancel'}
          onClick={close}
          isDisabled={isSaving}
        />
        <Button
          size={'Small'}
          type={'Primary'}
          label={'Remove'}
          onClick={onDelete}
          isLoading={isSaving}
          testId={'confirm-delete-exclusions'}
        />
      </Row>
    </Form>
  );
};

const Gate = ({ isOpen, close }: { isOpen: boolean; close: () => void }) => {
  return (
    <ModalTransition>
      {isOpen && (
        <ModalDialog
          onClose={close}
          shouldScrollInViewport={false}
          autoFocus={false}
        >
          <DeletePopup close={close} />
        </ModalDialog>
      )}
    </ModalTransition>
  );
};
export default Gate;
